import * as React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import './styles.scss';

interface TinyMCEEditorProps {
    value: string,
    onChange: (content: string) => void,
    height?: number,
    placeholder?: string,
    resize?: boolean,
    disabled?: boolean
}

const TinyMCEEditor: React.FC<TinyMCEEditorProps> = ({
    value,
    onChange,
    height = 500,
    placeholder = '',
    resize = false,
    disabled = false
}) => {
    return (
        <Editor
            apiKey={process.env.REACT_APP_TINY_API_KEY}
            value={value}
            disabled={disabled}
            onEditorChange={content => onChange(content)}

            init={{
                height,
                zIndex: 999999,
                fixed_toolbar_container: '.tox-toolbar-container',
                resize,
                body_class: disabled ?
                    'bg-[rgba(240,240,240,1)] border-[rgba(215,215,215,1)] cursor-not-allowed opacity-100' :
                    '',
                content_style: `
                    body {
                        padding: 16px;
                        background-color: ${disabled ? 'rgba(240,240,240,1)' : 'white'};
                        color: ${disabled ? '#000' : 'inherit'};
                        border-radius: 6px;
                    }
                    h1, h2, h3, h4, h5, h6 {
                        font-weight: bold;
                    }
                    h1 { font-size: 2em; }
                    h2 { font-size: 1.75em; }
                    h3 { font-size: 1.5em; }
                    h4 { font-size: 1.25em; }
                    h5 { font-size: 1.1em; }
                    h6 { font-size: 1em; }
                    `,

                menubar: false,
                plugins: [
                    'advlist',
                    'autolink',
                    'lists',
                    'link',
                    'image',
                    'charmap',
                    'preview',
                    'anchor',
                    'searchreplace',
                    'visualblocks',
                    'fullscreen',
                    'insertdatetime',
                    'table',
                    'code',
                    'fontsize'
                ],

                toolbar:
                    'undo redo | blocks | formatselect fontsizeinput | bold italic underline forecolor backcolor | ' +
                    'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | link image media table | fullscreen',

                block_formats:
                    'Paragraph=p; Heading 1=h1; Heading 2=h2; Heading 3=h3; Heading 4=h4; Heading 5=h5; Heading 6=h6',

                paste_data_images: true,

                images_upload_handler: blobInfo => new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blobInfo.blob());
                    reader.onload = () => resolve(reader.result as string);
                    reader.onerror = () => reject(reader.error);
                }),
                setup: (editor) => {
                    editor.on('init', () => {
                        editor.getBody().addEventListener('click', (e: any) => {
                            const target = e.target as HTMLElement;
                            if (target.tagName === 'A') {
                                e.preventDefault();
                                window.open((target as HTMLAnchorElement).href, '_blank');
                            }
                        });
                    });
                }

            }}
        />
    );
};

export default TinyMCEEditor;
